export default '6.2.0';



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/browser/appversion.tsx